<app-tab-menu class="menu"></app-tab-menu>
<div class="content">
	<div class="header">
		<h2>ETL starten</h2>
	</div>
	<div class="filter-bar">
		<div class="filter">
			<span>Bron</span>
			<app-single-select-dropdown [opties]="bronnen" (onOptieClicked)="bron.set($event)" [selectedOptie]="selectedBronOptie()">
			</app-single-select-dropdown>
		</div>
		<div class="filter">
			<span>Status laatste delta</span>
			<app-multi-select-dropdown
				[allOptions]="etlStatusOptions"
				(valueChange)="deltaLaatsteStatus.set($event)"
				[value]="deltaLaatsteStatus()"
				summaryAll="Alle"
			>
			</app-multi-select-dropdown>
		</div>
		<div class="filter">
			<span>Status laatste bulk</span>
			<app-multi-select-dropdown
				[allOptions]="etlStatusOptions"
				(valueChange)="bulkLaatsteStatus.set($event)"
				[value]="bulkLaatsteStatus()"
				summaryAll="Alle"
			>
			</app-multi-select-dropdown>
		</div>
		<div class="filter">
			<span>Zoek instelling</span>
			<app-instant-search-box (fire)="searchInput.set($event)" placeholder="Instelling zoeken"></app-instant-search-box>
		</div>
	</div>
	<div class="select-all">
		<app-checkbox [value]="allInstellingenChecked()" (valueChange)="selectAllOrNone($event)"> </app-checkbox>
		<span>Selecteer alle getoonde instellingen</span>
	</div>
	<app-instellingen-list
		[etlStatusEnabled]="true"
		[instellingen]="filteredInstellingen()"
		[checked]="checkedInstellingen()"
		(instellingClick)="updateChecked($event)"
	>
	</app-instellingen-list>
</div>
<div class="footer">
	<div class="footer-buttons">
		<app-button [enabled]="canStart()" (clickit)="startETLJob()">ETL Starten</app-button>
	</div>
</div>
